module.exports = __webpack_public_path__ + "img/title-bg.7c32192d.png";